import {TripCollection} from "../Trip";
import craciun from "../../../assets/child/craciun.jpg";

const dayChildCraciun: TripCollection = {
    imageSrc: craciun,
    trips: [
        {
            name: "Târgul de Crăciun Sibiu",
            route: "Excursie de sezon!\n",
            days: [
                [
                    {
                        locationName: "",
                    },
                ]
            ],
            notes: ""
        },
        {
            name: "Fabrica de Globuri Curtea de Argeş",
            route: "Excursie de sezon!\n",
            days: [
                [
                    {
                        locationName: "",
                    },
                ]
            ],
            notes: ""
        },
        {
            name: "Atelierul de Globuri Pucioasa",
            route: "Excursie de sezon!\n",
            days: [
                [
                    {
                        locationName: "",
                    },
                ]
            ],
            notes: ""
        },
    ]
}

export default dayChildCraciun;